import { render, staticRenderFns } from "./set-auto-rule.vue?vue&type=template&id=52ffd9d2&scoped=true"
import script from "./set-auto-rule.vue?vue&type=script&lang=ts"
export * from "./set-auto-rule.vue?vue&type=script&lang=ts"
import style0 from "./set-auto-rule.vue?vue&type=style&index=0&id=52ffd9d2&prod&lang=scss&scoped=true"
import style1 from "./set-auto-rule.vue?vue&type=style&index=1&id=52ffd9d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ffd9d2",
  null
  
)

export default component.exports